export const getEntitiesFeaturesList = ({ entitiesFeatures }) =>
  entitiesFeatures.list.data.items;

export const getEntitiesFeaturesCount = ({ entitiesFeatures }) =>
  entitiesFeatures.list.data.count;

export const getIsLoadingList = ({ entitiesFeatures }) =>
  entitiesFeatures.list.isLoading;

export const getPaginationOptions = ({ entitiesFeatures }) =>
  entitiesFeatures.list.paginationOptions;

export const getIsAdding = ({ entitiesFeatures }) =>
  entitiesFeatures.add.isLoading;

export const getIsUpdating = ({ entitiesFeatures }) =>
  entitiesFeatures.update.isLoading;

export const getIsDeleting = ({ entitiesFeatures }) =>
  entitiesFeatures.delete.isLoading;
